<template>
    <button type="button" class="btn btn-menu" id="btn-menu" @click="toggleMenu">
        <span class="btn-menu__hamburger">
            <span class="btn-menu__hamburger-inner"></span>
        </span>
    </button>
</template>

<script lang="ts" setup>
import { useHeader } from "@/composables/use-header";

const { toggleMenu } = useHeader();
</script>
